import { FC } from 'react'
import NotFound from 'components/pages/General/NotFound/NotFound'
import { Outlet } from 'react-router-dom'
import { WorkspaceNavigationContextProvider } from './contexts'
import { WorkspacesProfileContextProvider } from 'components/pages/Client/WorkspacesProfile/_main/WorkspacesProfile.context'
import { useUserData } from 'components/contexts/UserDataContext'

/** Parent wrapper component for workspace routes - provides contexts and renders Outlet for nested routes */
export const Workspace: FC = () => {
  const { currentUserWorkspace } = useUserData()

  return (
    <WorkspaceNavigationContextProvider>
      {currentUserWorkspace?.id ? (
        <WorkspacesProfileContextProvider workspaceId={currentUserWorkspace.id}>
          <Outlet />
        </WorkspacesProfileContextProvider>
      ) : (
        <NotFound />
      )}
    </WorkspaceNavigationContextProvider>
  )
}
